'use strict'
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import DropdownComponent from '../commonComponents/DropdownComponent';
import LoadingComponent from '../commonComponents/LoadingComponent';
import CallAPI from '../commonComponents/AxiosHelper';
import { connect } from 'react-redux';
import TagsComponent from '../commonComponents/TagsComponent';
import ModalComponent from '../commonComponents/ModalComponent'
import SelectSearch from '../commonComponents/SearchSelect';
import './css/style.css';

import ErrorComponent from '../commonComponents/ErrorComponent';

class TableTags extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                "transaction": [],
                "master": []
            },
            clickedTag:null
        }

   
        this.getTableColumns = this.getTableColumns.bind(this);
        this.handleTag = this.handleTag.bind(this);
        this.handleColumnChange = this.handleColumnChange.bind(this);

    }

    componentWillMount() {

    }

    getTableColumns(tableArray) {
        // let final_table_columns = [];
        if(tableArray !== null){
            let tableColumns = tableArray.map((element, i) => {
                let columns_array = JSON.parse(element.information)['column'];
                let innerArray = {};
                innerArray['id'] = element['raw_table'];
                innerArray['text'] = element['tableName'];
                innerArray['columnConfig'] = Object.values(columns_array).map((innerColumn, j) => {
                    let innerData = {};
                    // innerData['name'] = innerColumn;
                    // innerData['value'] = innerColumn;
                    innerData.id = j;
                    innerData.label = innerColumn;
                    innerData['type'] = element['type'];
                    innerData['tableValue'] = element['value'];
                    innerData['subtext_value'] = element['name'];
                    // innerData['tag_name'] = `${element['name']}.${innerColumn}`;
                    innerData['tag_name'] = `(${element['name']})${innerColumn}`;
                    return innerData;
                });

                return innerArray;
            });

            return tableColumns;
        }
        else{
            return null;
        }
       
    }

   

    submitTables() {
    

    }

    getStateFromChild(data, reference) {
        if (data !== null) {
            this.setState({
                joinData: data
            })
        }
    }


    handleTag(params){
        let clickedTag = params;
        this.setState({
            clickedTag:clickedTag
        })
        jQuery("#columnModal").modal('toggle');
    }

    handleColumnChange(e){

    }
    



    render() {
        
        let tableTags = this.getTableColumns(this.props.tagData);

        if(this.state.clickedTag !== null ){
            let column_array = {
                // "class": "my-1",
                "id": "master_table",
                "placeholder": "Select Columns",
                "size": 5,
                "value": [],
                "dropdownData": this.state.clickedTag['columnConfig'],
                "multi": true
            };
            // var dropdownBody = <DropdownComponent dropdownConfig={column_array} type="transaction" onChange={this.handleColumnChange} />
            var dropdownBody = <SelectSearch itemData={this.state.clickedTag['columnConfig']}/>;
        }

        var modalConfig = {
            "columnModal": {
                "form_name": "add_form", "id": "columnModal", "title": "Exclude Columns", "body": dropdownBody, "button_name": "Exclude", "action": "column", "display": true
            }
        };





        return (
            <>
                
                <TagsComponent tagClick={this.handleTag} placeholder={""} tags={tableTags} suggestions={[]} controlState={this.getStateFromChild} />
                <ModalComponent modalConfig={modalConfig["columnModal"]} action={this.handleModalButtonAction} />
            </>
        )
    }
}

function mapStateToProps(state) {
    return { tableData: state.dataset.tableData };

}


// function mapDispatchToProps(dispatch) {
//     return bindActionCreators({
//         setToolId
//     }, dispatch)
// }

export default connect(mapStateToProps, null)(TableTags);
// export default DataMerge;

